<div class="alert-delivery-failures ion-padding">
  <h2>{{ 'ACCOUNT_ADMIN.ALERT_DELIVERY_FAILURES_TITLE' | translate }}</h2>
  <p class="subtitle">{{ 'ACCOUNT_ADMIN.ALERT_DELIVERY_FAILURES_SUBTITLE' | translate }}</p>

  <ion-card *ngIf="error" color="light">
    <ion-card-content>{{ error }}</ion-card-content>
  </ion-card>

  <ion-item lines="full">
    <ion-input
      [(ngModel)]="searchSerial"
      [label]="'ADMIN.ALERT_DELIVERY_FAILURES_SEARCH_SERIAL' | translate"
      labelPlacement="stacked"
      type="text"
      (keyup.enter)="loadFailures()">
    </ion-input>
    <ion-button slot="end" fill="clear" (click)="loadFailures()" [disabled]="loading">
      {{ 'ADMIN.ALERT_DELIVERY_FAILURES_SEARCH_BUTTON' | translate }}
    </ion-button>
  </ion-item>

  <div *ngIf="loading" class="loading-row">
    <ion-spinner name="crescent"></ion-spinner>
    <span>{{ 'ADMIN.LOGIN_FAILURES_LOADING' | translate }}</span>
  </div>

  <div *ngIf="!loading && list.length === 0" class="empty-row">
    {{ 'ACCOUNT_ADMIN.ALERT_DELIVERY_FAILURES_EMPTY' | translate }}
  </div>

  <ion-accordion-group *ngIf="!loading && list.length > 0">
    <ion-accordion *ngFor="let row of list" [value]="row.id">
      <ion-item slot="header">
        <ion-label>
          <h3>{{ row.kiln_name || row.serial_number || ('ADMIN.ALERT_DELIVERY_FAILURES_UNKNOWN_KILN' | translate) }}</h3>
          <p>{{ formatDate(row.created_at) }} · {{ formatFailureCategory(row.failure_category) }}</p>
        </ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <p>{{ row.admin_message }}</p>
        <p *ngIf="row.user_message"><em>{{ row.user_message }}</em></p>
        <ul *ngIf="row.send_failures?.length">
          <li *ngFor="let failure of row.send_failures">
            {{ formatChannel(failure.channel) }} → {{ failure.recipient }}:
            {{ failure.error_message || ('ADMIN.ALERT_DELIVERY_FAILURES_UNKNOWN_ERROR' | translate) }}
          </li>
        </ul>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</div>
